module.exports = __webpack_public_path__ + "img/bg2.68fc7a41.png";